export const WATCH_BLOCK_VERSION_LOCAL_KEY = 'WATCH_BLOCK_VERSION_LOCAL_KEY';
export const WATCH_BLOCK_VERSION_1 = 'WATCH_BLOCK_VERSION_1';
export const WATCH_BLOCK_VERSION_2 = 'WATCH_BLOCK_VERSION_2';
